import { gql } from '@apollo/client';

export const GET_ADDITIONAL_VEHICLE_LIST = gql`
  query GetAdditionalRequestBasedOnFilters(
    $filters: [Filter!]
    $limit: Float
    $offset: Float
    $order: OrderBy
  ) {
    getAdditionalRequestBasedOnFilters(
      filters: $filters
      limit: $limit
      offset: $offset
      order: $order
    ) {
      count
      hasMore
      rows {
        additionalRequestId
        additionalRequestNumber
        boac
        customerId
        customerName
        requestStatusCode
        requestType
        sin
      }
    }
  }
`;

export const CREATE_ADDITIONAL_REQUEST_NOTE = gql`
  mutation CreateRequestAdditionalNote($input: AdditionalRequestNoteInput!) {
    createRequestAdditionalNote(input: $input) {
      additionalRequestCommentId
    }
  }
`;

export const GET_CUSTOMER_ACCOUNT_BASED_ON_FILTERS = gql`
  query GetCustomerAccountBasedOnFilters(
    $limit: Float
    $offset: Float
    $order: OrderBy
    $filters: [Filter!]
  ) {
    getCustomerAccountBasedOnFilters(
      limit: $limit
      offset: $offset
      order: $order
      filters: $filters
    ) {
      rows {
        agencyCode
        agencyName
        boac
        bureauCode
        bureauName
        officeCode
        officeName
        zoneId
        customerAccountId
        customerEmailAddress
        legacyCustomerNumber
        fmcName
        customerName
        fsrEmailAddress
        officeAddressLine1
        officeAddressLine2
        officeCity
        officeState
        postalcode
        hasDelinquentBills
      }
    }
  }
`;

export const CREATE_ADDITIONAL_REQUEST = gql`
  mutation CreateAdditionalRequest($input: AdditionalRequestInput!) {
    createAdditionalRequest(input: $input) {
      customerAccount {
        agencyCode
        agencyName
        boac
        boacId
        agencyName
        bureauCode
        bureauName
        customerAccountId
        customerEmailAddress
        customerName
        fmcName
        fsrEmailAddress
        fsrName
        legacyCustomerNumber
        officeAddressLine1
        officeAddressLine2
        officeCity
        officeCode
        officeName
        officeState
        postalcode
        zoneId
      }
      additionalRequestGarageAddress {
        additionalGarageAddressId
        addressLine1
        addressLine2
        city
        countryCode
        stateCode
        zipcode
      }
      additionalRequestId
      customerId
      requestType
      requestVehicleSin
      requestStatusCode
      acknowledged
      acknowledgedSubmit
      towingWeight
      missionMakeModel
      specificInstructions
      fiscalYear
      approvalLevel
      canReturnRequest
      additionalRequestNumber
      deliquencyCheck
      additionalRequestComments {
        additionalRequestComment
        additionalRequestCommentId
        additionalRequestId
        createdAt
        updatedAt
      }
      sin
      additionalRequestOptions {
        equipmentCode
        comment
      }
      additionalRequestActivities {
        activityTitle
        additionalRequestStatusCode
        additionalActivityLogId
        additionalRequestComment
        additionalRequestId
        createdAt
        updatedAt
        createdBy
        createdByUser {
          fullName
        }
      }
      additionalRequestAttachments {
        additionalRequestId
        additionalAttachmentTypeId
        additionalRequestAttachmentId
        metadataId
        name
        description
        createdAt
      }
      createdByUser {
        email
      }
      fundingDate
      fundingStatusReason
      fundingStatus
      fundingApprovedBy
      filledWithInventory
      fillInVehicleDetailsComment
    }
  }
`;

export const GET_ADDITIONAL_REQUEST = gql`
  query GetAdditionalRequest($additionalRequestId: String!) {
    getAdditionalRequest(additionalRequestId: $additionalRequestId) {
      customerAccount {
        agencyCode
        agencyName
        boac
        boacId
        agencyName
        bureauCode
        bureauName
        customerAccountId
        customerEmailAddress
        customerName
        fmcName
        fsrEmailAddress
        fsrName
        legacyCustomerNumber
        officeAddressLine1
        officeAddressLine2
        officeCity
        officeCode
        officeName
        officeState
        postalcode
        zoneId
      }
      requisitionId
      requisitionNumber
      deliquencyCheck
      additionalRequestGarageAddress {
        additionalGarageAddressId
        addressLine1
        addressLine2
        city
        countryCode
        stateCode
        zipcode
      }
      additionalRequestId
      customerId
      requestType
      requestVehicleSin
      requestStatusCode
      acknowledged
      acknowledgedSubmit
      towingWeight
      missionMakeModel
      specificInstructions
      fiscalYear
      approvalLevel
      canReturnRequest
      additionalRequestNumber
      validFunding
      additionalRequestComments {
        additionalRequestComment
        additionalRequestCommentId
        additionalRequestId
        createdAt
        updatedAt
      }
      sin
      additionalRequestOptions {
        equipmentCode
        comment
      }
      additionalRequestActivities {
        activityTitle
        additionalRequestStatusCode
        additionalActivityLogId
        additionalRequestComment
        additionalRequestId
        createdAt
        updatedAt
        createdBy
        createdByUser {
          fullName
        }
      }
      additionalRequestAttachments {
        additionalRequestId
        additionalAttachmentTypeId
        additionalRequestAttachmentId
        metadataId
        name
        description
        createdAt
      }
      createdByUser {
        email
      }
      fundingDate
      fundingStatusReason
      fundingStatus
      fundingApprovedBy
      filledWithInventory
      fillInVehicleDetailsComment
      fundingApprovedByUser {
        fullName
      }
    }
  }
`;

export const CANCEL_ADDITIONAL_REQUEST = gql`
  mutation CancelAdditionalRequest($additionalRequestId: String!) {
    cancelAdditionalRequest(additionalRequestId: $additionalRequestId)
  }
`;

export const CREATE_ADDITIONALS_ATTACHMENTS = gql`
  mutation CreateAdditionalRequestAttachment(
    $input: CreateAdditionalRequestAttachmentTypeInput!
  ) {
    createAdditionalRequestAttachment(input: $input) {
      additionalAttachmentTypeId
      additionalRequestId
      metadataId
      name
      description
      additionalRequestAttachmentId
    }
  }
`;

export const UPDATE_ADDITIONALS_ATTACHMENTS = gql`
  mutation UpdateAdditionalRequestAttachment(
    $input: UpdateAdditionalRequestAttachmentTypeInput!
  ) {
    updateAdditionalRequestAttachment(input: $input) {
      additionalAttachmentTypeId
      additionalRequestAttachmentId
      additionalRequestId
      createdAt
      createdBy
      description
      metadataId
      name
    }
  }
`;

export const DELETE_ADDITIONALS_ATTACHMENT = gql`
  mutation DeleteAdditionalRequestAttachment(
    $additionalRequestAttachmentId: String!
  ) {
    deleteAdditionalRequestAttachment(
      additionalRequestAttachmentId: $additionalRequestAttachmentId
    )
  }
`;

export const RETURN_ADDITIONAL_REQUEST = gql`
  mutation ReturnAdditionalRequest(
    $additionalRequestId: String!
    $returnReason: String
  ) {
    returnAdditionalRequest(
      additionalRequestId: $additionalRequestId
      returnReason: $returnReason
    )
  }
`;

export const FILL_VEHICLE_REQUEST = gql`
  mutation FillInVehicle(
    $fillInVehicleDetailsComment: String!
    $additionalRequestId: String!
  ) {
    fillInVehicle(
      fillInVehicleDetailsComment: $fillInVehicleDetailsComment
      additionalRequestId: $additionalRequestId
    )
  }
`;

export const ADDITIONAL_OVERRIDE_SIN = gql`
  mutation AdditionalRequestOverrideSin($input: AdditionalOverrideSinInput!) {
    additionalRequestOverrideSin(input: $input)
  }
`;

export const UPDATE_FUNDING_STATUS = gql`
  mutation UpdateFundingStatus(
    $additionalRequestIds: [String!]!
    $fundingStatus: String!
    $fundingStatusReason: String
  ) {
    updateFundingStatus(
      additionalRequestIds: $additionalRequestIds
      fundingStatus: $fundingStatus
      fundingStatusReason: $fundingStatusReason
    )
  }
`;

export const UPDATE_ADDITIONAL_REQUEST_BACK_TO_FUNDING = gql`
  mutation UpdateAdditonalRequestBackToFunding(
    $requestStatusCode: String!
    $additionalRequestId: String!
    $returnFunding: Boolean
  ) {
    updateAdditonalRequestBackToFunding(
      requestStatusCode: $requestStatusCode
      additionalRequestId: $additionalRequestId
      returnFunding: $returnFunding
    )
  }
`;
